module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow</title><path d=\"M14.86,4.75,28.63,22h-.1l2.4,2.93-2.36,2.92h.07L14.86,45a3.11,3.11,0,0,0,.46,4.12,2.94,2.94,0,0,0,4.12-.46L37,26.71a2.67,2.67,0,0,0,.64-1.83h0A4.32,4.32,0,0,0,37,23.05l-17.57-22A3,3,0,0,0,15.32.63,3,3,0,0,0,14.86,4.75Z\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/smaller-arrow.icon.html
// module id = 86
// module chunks = 1